(function () {
    'use strict';

    angular.module('app').controller('PaymentController', PaymentController);

    PaymentController.$inject = [
        '$rootScope',
        '$scope',
        '$window',
        '$http',
        '$route',
        '$routeParams',
        '$location',
        'blockUI',
        '$uibModal',
        'BusinessService',
        'UserService'];

    function PaymentController(
        $rootScope, $scope, $window, $http, $route, $routeParams, $location, blockUI, $uibModal, BusinessService, UserService) {

        $scope.isRouteStatus = isRouteStatus;
        $scope.isHaveStripeSavedCards = _stripeHaveSavedCards;

        // Поддерживаемые страны для платежной системы flutterwave
        $scope.flutterwaveSupportedCoutries = [
            'GH', //"Ghana"
            'KE', //"Kenya"
            'NG', //"Nigeria"
            'UG', //"Uganda"
            'RW', //"Rwanda"
            'ZA', //"South Africa"
            'TZ', //"Tanzania"
            'ZM', //"Zambia"
            'CM', //"Cameroon"
            'CI' //"Ivory Coast
        ];

        $scope.isTestServer = $rootScope.appConfig.apiBase.includes('https://test') !== -1;

        $scope.viewContentLoaded = false;

        $scope.model = {};
        $scope.business = {};

        $scope.inlineMessage = '';

        $scope.stripe = null;
        $scope.liqpay = null;
        $scope.stripeElements = null;
        $scope.stripeCardElement = null;
        $scope.stripeCardElementStyle = {
            base: {
                color: '#32325d',
                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                fontSmoothing: 'antialiased',
                fontSize: '16px',
                '::placeholder': {
                    color: '#aab7c4'
                }
            },
            invalid: {
                color: '#fa755a',
                iconColor: '#fa755a'
            }
        };

        // используется только для отладки
        $scope.wfp = {
            onApproved: {},
            onDeclined: {}
        };

        $scope.settingsStripe = {};

        $scope.inlineMessageStripe = '';

        $scope.isIncust = appConfig.platformParams.main_site.en === 'incust.com';
        $scope.isPrimeFuel = appConfig.platformParams.main_site.en === 'prime-fuel.com';
        $scope.stripe_support = appConfig.platformParams.stripe_support;

        var block_payments = blockUI.instances.get('payments');

        initController();

        // *********************************************************************************************
        //  MAIN PART
        // *********************************************************************************************

        function isRouteStatus(status) {
            return $routeParams && $routeParams.hasOwnProperty('status') && $routeParams.status === status;
        }

        /**
         * Initialize controller
         */
        function initController() {
            _loadLegalInfo();
            _loadBusiness();
            _loadUser();
            _loadStripeSettings();

            $scope.availablePayments = $rootScope.appConfig.available_payments.find(function (el) {
                return $rootScope.ENV.business.country === el.country;
            })

            if (!$scope.availablePayments) {
                $scope.availablePayments = $rootScope.appConfig.available_payments.find(function (el) {
                    return el.country === 'default';
                })
            }

            $scope.model = angular.copy($rootScope.appConfig.payment);
            $scope.model.amount_flutterwave = 1;

            var isSupportCountry = $scope.flutterwaveSupportedCoutries.includes($rootScope.ENV.business.country);
            $scope.model.showFlutterwave = $scope.isTestServer ? isSupportCountry ||
                ['USD', 'EUR', 'GBP'].includes($rootScope.ENV.business.currency) : isSupportCountry;

            // $scope.model.recurrent_payment_card_value = $rootScope.ENV.business.auto_pay_balance_edge
            $scope.model.amount = $scope.model.min_amount_usd;
            $scope.model.amount_min = $scope.model.min_amount_usd;
            $scope.model.recurrent_payment_card_value = $scope.model.min_amount_usd;
            switch ($rootScope.ENV.business.currency) {
                case 'UAH':
                    $scope.model.recurrent_payment_card_value = $scope.model.min_amount_uah;
                    $scope.model.amount = $scope.model.min_amount_uah;
                    $scope.model.amount_min = $scope.model.min_amount_uah;
                    break;
                case 'RUB':
                    $scope.model.recurrent_payment_card_value = $scope.model.min_amount_rub;
                    $scope.model.amount = $scope.model.min_amount_rub;
                    $scope.model.amount_min = $scope.model.min_amount_rub;
                    break;
                case 'KZT':
                    $scope.model.amount = $scope.model.min_amount_kzt;
                    $scope.model.amount_min = $scope.model.min_amount_kzt;
                    break;
            }

            imgToDataUrl('/assets/img/payment/seal.png', function (seal) {
                $scope.img_seal = seal;
            });
            imgToDataUrl('/assets/img/payment/sign.png', function (sign) {
                $scope.img_sign = sign;
            });

            if (isRouteStatus('success') || isRouteStatus('cancel')) {
                popupPaymentStatus(isRouteStatus('success') ? 'success' : 'cancel');
            }
        }

        $scope.$on('$viewContentLoaded', function () {
            $scope.viewContentLoaded = true;

            if ($scope.stripe === null || $scope.stripe === undefined ||
                $scope.stripeElements === null || $scope.stripeElements === undefined ||
                $scope.stripeCardElement === null || $scope.stripeCardElement === undefined) {

                _stripeInit();
            }
        });

        function popupPaymentStatus(status) {
            $scope.paymentStatus = $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                size: 'md',
                templateUrl: 'app/templates/modal.payment.status.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;

                    popup.model = {
                        status: status
                    };

                    popup.onOkClick = function () {
                        $rootScope.getBusinessStatus();

                        $uibModalInstance.close();
                        _loadStripeSettings();
                        if ($location.path() != '/payment') {
                            $location.path('/payment');
                        } else {
                            $route.reload();
                        }
                    };
                }
            });
        }

        function _loadLegalInfo() {
            BusinessService.LegalInfo(function (success, data) {
                if (success) {
                    $scope.legal_info = data;
                }
            });
        }

        function _loadBusiness() {
            BusinessService.GetWithTariff(function (success, data) {
                if (success) {
                    $scope.business = data;
                }
            });
        }

        function _loadUser() {
            UserService.Profile(function (success, user) {
                if (success) {
                }
            });
        }

        function _loadStripeSettings() {
            BusinessService.BaseSettingsStripe(function (success, data) {
                if (success) {
                    $scope.settingsStripe = angular.copy(data);
                    $scope.stripeIsCheckoutSupported = !!($scope.settingsStripe.integration_types || []).includes('checkout');
                    $scope.model.amount_stripe = $scope.settingsStripe.min_amount;

                    switch ($scope.settingsStripe.currency) {
                        case 'UAH':
                            if ($scope.model.amount_uah >= $scope.settingsStripe.min_amount) {
                                $scope.model.amount_stripe = $scope.model.amount_uah;
                            }
                            if ($scope.model.min_amount_uah >= $scope.settingsStripe.min_amount) {
                                $scope.settingsStripe.min_amount = $scope.model.min_amount_uah;
                            }
                            break;
                        case 'RUB':
                            if ($scope.model.amount_rub >= $scope.settingsStripe.min_amount) {
                                $scope.model.amount_stripe = $scope.model.amount_rub;
                            }
                            if ($scope.model.min_amount_rub >= $scope.settingsStripe.min_amount) {
                                $scope.settingsStripe.min_amount = $scope.model.min_amount_rub;
                            }
                            break;
                        case 'KZT':
                            if ($scope.model.amount_kzt >= $scope.settingsStripe.min_amount) {
                                $scope.model.amount_stripe = $scope.model.amount_kzt;
                            }
                            if ($scope.model.min_amount_kzt >= $scope.settingsStripe.min_amount) {
                                $scope.settingsStripe.min_amount = $scope.model.min_amount_kzt;
                            }
                            break;
                        case 'USD':
                            if ($scope.model.amount_usd >= $scope.settingsStripe.min_amount) {
                                $scope.model.amount_stripe = $scope.model.amount_usd;
                            }
                            if ($scope.model.min_amount_usd >= $scope.settingsStripe.min_amount) {
                                $scope.settingsStripe.min_amount = $scope.model.min_amount_usd;
                            }
                            break;
                    }

                    if ($scope.settingsStripe.saved_payment_methods && $scope.settingsStripe.saved_payment_methods.length > 0) {
                        $scope.model.stripe_saved_card_id = $scope.settingsStripe.saved_payment_methods[0].id;
                    }

                    // Init Stripe
                    _stripeInit();
                }
            });
        }

        function _stripeInit() {
            if ($scope.viewContentLoaded === true
                && ($scope.settingsStripe.key !== null && $scope.settingsStripe.key !== undefined)
                && 'Stripe' in window
            ) {
                $scope.stripe = Stripe($scope.settingsStripe.key);

                if ($scope.stripe === null || $scope.stripe === undefined) {
                    console.warn('Stripe init failed');
                    return;
                }

                $scope.stripeElements = $scope.stripe.elements();

                if ($scope.stripeElements === null || $scope.stripeElements === undefined) {
                    console.warn('Stripe Elements init failed');
                    return;
                }

                $scope.stripeCardElement = $scope.stripeElements.create('card',
                    {
                        style: $scope.stripeCardElementStyle,
                        hidePostalCode: true
                    }
                );

                if ($scope.stripeCardElement === null || $scope.stripeCardElement === undefined) {
                    console.warn('Stripe Card Elements init failed');
                    return;
                }

                $scope.stripeCardElement.mount('#card-element');

                $scope.stripeCardElement.addEventListener('change', function (event) {
                    if (event.error) {
                        _stripeDisplayError(event.error.message, false);
                    } else {
                        _stripeDisplayError('', false);
                    }
                });
            }
        }

        function _stripeDisplayError(message, saved) {
            var displayError = document.getElementById((saved === true) ? 'saved-card-errors' : 'card-errors');
            if (displayError) {
                displayError.textContent = message;
            }
        }

        function _stripeBlockUI() {
            block_payments.start();
        }

        function _stripeUnblockUI() {
            block_payments.stop();
            $scope.$digest();
        }

        function _stripeHaveSavedCards() {
            if ($scope.settingsStripe.saved_payment_methods && $scope.settingsStripe.saved_payment_methods.length > 0) {
                return true;
            }

            return false;
        }

        $scope.cardBrandImage = function (brand) {
            if (brand === undefined || brand === null) {
                return '';
            }
            switch (brand.toLocaleLowerCase()) {
                case 'visa':
                    return 'assets/img/payment/visa.svg';
                case 'mastercard':
                    return 'assets/img/payment/mastercard.svg';
                case 'amex':
                    return 'assets/img/payment/amex.svg';
                case 'diners':
                    return 'assets/img/payment/diners.svg';
                case 'discover':
                    return 'assets/img/payment/discover.svg';
                case 'jcb':
                    return 'assets/img/payment/jcb.svg';
                case 'unionpay':
                    return 'assets/img/payment/unionpay.svg';
                case 'unknown':
                    return 'assets/img/payment/mastercard.svg';
                default:
                    return '';
            }
        };

        $scope.onPayLiqPay = function (currency) {
            $scope.liqpay = true;

            var post_data = {
                amount: $scope.model.amount,
                currency: currency,
                success_url: window.location.href,
                fail_url: window.location.href
            }

            BusinessService.AccountRefillLiqpayNew(post_data, function (success, new_data) {
                if (success) {
                    var result = angular.copy(new_data)
                    var url = 'https://www.liqpay.ua/api/3/checkout' + '?data=' + result.data + '&signature=' + result.signature
                    window.open(url, '_self');
                }
            })
        }

        $scope.onPayWFP = function (payment_type, currency) {
            console.log(222222, $scope.model)
            switch (currency) {
                case 'RUB':
                case 'USD':
                case 'UAH':
                case 'KZT':
                    if (!$scope.model.amount || ($scope.model.amount && $scope.model.amount < $scope.model.amount_min)) {
                        $scope.inlineMessage = 'Minimum amount';
                        break;
                    }
                    var post_data = {
                        order_date: moment().format('X') | 0,
                        product_name: 'Account Refill, ' + $rootScope.ENV.business.title,
                        product_count: 1,
                        currency: currency,
                        amount: $scope.model.amount,
                        product_price: $scope.model.amount
                    };

                    block_payments.start();
                    BusinessService.AccountRefillWayForPay(post_data, function (success, response) {
                        if (success) {
                            $scope.wfp = {};
                            var payment = angular.copy(response);
                            var wayforpay = new Wayforpay();

                            //$analytics.eventTrack(post_data.amount + post_data.currency, {  category: 'Payment', label: 'Business panel' });
                            $window.ga('send', 'event', 'Business panel', 'Payment', post_data.amount + post_data.currency);

                            block_payments.stop();

                            wayforpay.run(
                                {
                                    merchantAccount: payment.merchant_account,
                                    merchantDomainName: payment.merchant_domain_name,
                                    authorizationType: 'SimpleSignature',
                                    merchantSignature: payment.merchant_signature,
                                    orderReference: payment.order_reference,
                                    orderDate: post_data.order_date.toString(),
                                    amount: post_data.amount.toString(),
                                    currency: post_data.currency,
                                    productName: post_data.product_name,
                                    productPrice: post_data.product_price.toString(),
                                    productCount: post_data.product_count.toString(),
                                    clientFirstName: $rootScope.ENV.business.title,
                                    clientLastName: $rootScope.ENV.business.title,
                                    clientEmail: $rootScope.USER.login,
                                    clientPhone: payment_type !== 'lpTerminal' ? $rootScope.USER.phone : '',
                                    language: 'AUTO',
                                    paymentSystems: payment_type,
                                    serviceUrl: payment.payment_processing_url,
                                    returnUrl: payment.payment_processing_url
                                },
                                function (response) {
                                    // on approved
                                    console.log('wayforpay on approved');
                                    console.log(response);
                                    $scope.wfp.onApproved = response;

                                    if ($scope.model.recurrent_payment_card)
                                        recurrentWayForPayPaymentSetup(response, post_data);
                                },
                                function (response) {
                                    // on declined
                                    console.log('wayforpay on declined');
                                    console.log(response);
                                    $scope.wfp.onDeclined = response;
                                },
                                function (response) {
                                    // on pending or in processing
                                    if ($scope.model.recurrent_payment_card)
                                        recurrentWayForPayPaymentSetup(response, post_data);
                                }
                            );
                        } else {
                            block_payments.stop();
                        }
                    });
                    break;
                default:
                    $scope.inlineMessage = 'Minimum amount';
                    break;
            }
        };

        $scope.onPayPayPro = function (currency) {
            switch (currency) {
                case 'RUB':
                case 'USD':
                case 'UAH':
                case 'KZT':
                    console.log($scope.model.amount, $scope.model.amount_min)
                    if (!$scope.model.amount || ($scope.model.amount && $scope.model.amount < $scope.model.amount_min)) {
                        $scope.inlineMessage = 'Minimum amount';
                        break;
                    }
                    var pay_link = 'https://store.payproglobal.com/checkout?';

                    var post_data = {
                        amount: $scope.model.amount,
                        currency: currency
                    };

                    block_payments.start();
                    BusinessService.AccountRefillPayPro(post_data, function (success, response) {
                        if (success) {
                            pay_link += 'billing-country=' + $rootScope.ENV.business.country +
                                '&billing-first-name=' + $rootScope.USER.name +
                                '&billing-email=' + $rootScope.USER.login +
                                '&billing-contact-phone=' + $rootScope.USER.phone;

                            if ($scope.model.pay_pro_test_mode) {
                                pay_link += '&use-test-mode=' + $scope.model.pay_pro_test_mode +
                                    '&secret-key=wMEKYDfTLg';
                            }

                            switch (currency) {
                                case 'RUB':
                                    pay_link += '&currency=RUB&products[1][id]=' + $scope.model.pay_pro_rub_id;
                                    $window.ga('send', 'event', 'Business panel', 'Payment', $scope.model.amount + 'RUB');
                                    break;
                                case 'USD':
                                    pay_link += '&currency=USD&products[1][id]=' + $scope.model.pay_pro_usd_id;
                                    $window.ga('send', 'event', 'Business panel', 'Payment', $scope.model.amount + 'USD');
                                    break;
                                case 'KZT':
                                    pay_link += '&currency=KZT&products[1][id]=' + $scope.model.pay_pro_kzt_id;
                                    $window.ga('send', 'event', 'Business panel', 'Payment', $scope.model.amount + 'KZT');
                                    break;
                            }

                            pay_link += '&products[1][data]=' + response.encrypted_data;


                            block_payments.stop();

                            $window.open(pay_link, '_self');
                        } else {
                            block_payments.stop();
                        }
                    });
                    break;
                default:
                    $scope.inlineMessage = 'Minimum amount';
                    break;
            }
        };

        $scope.onPayStripe = function (currency) {

            if (!$scope.stripeIsCheckoutSupported) {
                if ($scope.stripe === null || $scope.stripe === undefined ||
                    $scope.stripeCardElement === null || $scope.stripeCardElement === undefined) {
                    _stripeDisplayError('Payment method initialization failed', false);
                    return;
                }
            }

            if (currency === $scope.settingsStripe.currency && $scope.model.amount_stripe >= $scope.settingsStripe.min_amount) {
                var post_data = {
                    save_for_future_use: !!$scope.model.stripe_save_for_future,
                    integration_type: $scope.stripeIsCheckoutSupported ? 'checkout' : 'elements',
                    amount: $scope.model.amount_stripe,
                    currency: currency
                };
                if ($scope.stripeIsCheckoutSupported) {
                    post_data.success_url = location.origin + '/payment/success';
                    post_data.cancel_url = location.origin + '/payment/cancel';
                }
                if (!$scope.stripeIsCheckoutSupported) {
                    _stripeDisplayError('', false);

                }
                _stripeBlockUI();
                BusinessService.AccountRefillStripeNew(post_data, function (success, response) {
                    if (success) {

                        $window.ga('send', 'event', 'Business panel', 'Payment', post_data.amount + post_data.currency);

                        if ($scope.stripeIsCheckoutSupported && response.integration_type == 'checkout' && !!response.url) {
                            window.open(response.url, '_self');

                            return;
                        }

                        // _stripeUnblockUI();

                        $scope.stripe.handleCardPayment(response.secret, $scope.stripeCardElement, {}).then(function (result) {
                            console.info('result', result);
                            _stripeUnblockUI();
                            if (result.error) {
                                // Display error.message in your UI.
                                _stripeDisplayError(result.error.message, false);
                            } else {
                                // The payment has succeeded. Display a success message.
                                popupPaymentStatus('success');
                            }
                        });
                    } else {
                        _stripeUnblockUI();
                    }
                });
            } else {
                $scope.inlineMessageStripe = 'Minimum amount';
            }
        };

        $scope.onPayStripeSaved = function (currency) {
            if ($scope.stripe === null || $scope.stripe === undefined) {
                _stripeDisplayError('Payment method initialization failed', true);
                return;
            }
            if ($scope.model.stripe_saved_card_id === null || $scope.model.stripe_saved_card_id === undefined) {
                _stripeDisplayError('Payment method initialization failed', true);
                return;
            }
            if (currency === $scope.settingsStripe.currency && $scope.model.amount_stripe >= $scope.settingsStripe.min_amount) {
                var post_data = {
                    card_id: $scope.model.stripe_saved_card_id,
                    integration_type: 'elements',
                    amount: $scope.model.amount_stripe,
                    currency: currency
                };

                _stripeDisplayError('', true);
                _stripeBlockUI();

                BusinessService.AccountRefillStripeSaved(post_data, function (success, response) {
                    if (success) {
                        //$analytics.eventTrack(post_data.amount + post_data.currency, {  category: 'Payment', label: 'Business panel' });
                        $window.ga('send', 'event', 'Business panel', 'Payment', post_data.amount + post_data.currency);

                        // _stripeUnblockUI();

                        $scope.stripe.handleCardPayment(response.secret, {}
                        ).then(function (result) {
                            console.info('result', result);

                            _stripeUnblockUI();

                            if (result.error) {
                                // Display error.message in your UI.
                                _stripeDisplayError(result.error.message, true);

                            } else {
                                // The payment has succeeded. Display a success message.
                                popupPaymentStatus('success');
                            }
                        });
                    } else {
                        _stripeUnblockUI();
                    }
                });
            } else {
                $scope.inlineMessageStripe = 'Minimum amount';
            }
        };

        $scope.onPayBill = function () {

            switch ($rootScope.ENV.business.country) {
                case 'UA':
                    formBillPDFUA();
                    break;
                case 'RU':
                    formBillPDFRU();
                    break;
            }

            // pdfMake.createPdf($scope.bill).open();
            pdfMake.createPdf($scope.bill).download($rootScope.ENV.business.code + '_invoice_' + moment().format('YYYY-MM-DD'));
        };

        $scope.onAmountChange = function () {
            $scope.inlineMessage = '';
            $scope.inlineMessageStripe = '';
        };

        function recurrentLiqpayPaymentSetup(data) {
            if (!$scope.model.recurrent_payment_card_value)
                $scope.model.recurrent_payment_card_value = 0;

            data.balance_amount = $scope.model.recurrent_payment_card_value;

            BusinessService.AccountRecurrentLiqpay(data, function (success, response) {
                if (success) {
                    _loadBusiness();
                }
            })
        }

        function recurrentWayForPayPaymentSetup(data) {
            if (!$scope.model.recurrent_payment_card_value)
                $scope.model.recurrent_payment_card_value = 0;

            data.balance_amount = $scope.model.recurrent_payment_card_value;
            BusinessService.AccountRecurrentWayForPay(data, function (success, response) {
                if (success) {
                    _loadBusiness();
                }
            })
        }

        $scope.disableAutoPay = function () {
            $scope.model.recurrent_payment_card = true;
            BusinessService.AccountDisableAutoPay(function (success, data) {
                if (success) {
                    _loadBusiness();
                }
            })
        }

        function formBillPDFUA() {

            var client_info = [];

            if ($scope.legal_info.legal_ownership_type)
                client_info.push($scope.legal_info.legal_ownership_type + '\n');

            if ($scope.legal_info.name_for_invoice)
                client_info.push($scope.legal_info.name_for_invoice + '\n');

            if ($scope.legal_info.details_for_invoice)
                client_info.push($scope.legal_info.details_for_invoice + '\n');

            if ($scope.legal_info.post_address)
                client_info.push($scope.legal_info.post_address + '\n');

            if ($scope.legal_info.accounting_phone)
                client_info.push($scope.legal_info.accounting_phone + '\n');

            if ($scope.legal_info.accounting_email)
                client_info.push($scope.legal_info.accounting_email + '\n');

            if ($scope.legal_info.legal_address)
                client_info.push($scope.legal_info.legal_address + '\n');

            $scope.bill = {
                pageSize: 'A4',
                pageMargins: [40, 30, 40, 20], // left, top, right, bottom
                content: [
                    {
                        columns: [
                            {
                                width: '30%',
                                text: 'Постачальник',
                                style: 'boldundeline'
                            },
                            {
                                width: '70%',
                                text: [
                                    'Товариство з Обмеженою Відповідальністю "Софтпанорама Плюс Плюс"\n',
                                    'КОД ЄДРПОУ 32849350\n',
                                    'Платник єдиного податку — 5% : № св. 252688 від 04.05.2012р\n',
                                    'Україна 02152, м.Київ, пр-т Тичини, 20\n',
                                    'Тел. Бухгалтерія: +38044-394-9594\n',
                                    'Тел. +38044-394-9594\n',
                                    'Банківскі реквізити:\n',
                                    'МФО 305299,\n',
                                    'АТ КБ "ПРИВАТБАНК"\n',
                                    'IBAN UA58 305299 00000 26000036224392'],
                                fontSize: 10
                            }
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        columns: [
                            {
                                width: '30%',
                                text: 'Одержувач',
                                style: 'boldundeline'
                            },
                            {
                                width: '50%',
                                text: client_info,
                                fontSize: 10
                            }
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        columns: [
                            {
                                width: '30%',
                                text: 'Платник',
                                style: 'boldundeline'
                            },
                            {
                                width: '50%',
                                text: ['Той самий'],
                                fontSize: 10
                            }
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        columns: [
                            {
                                width: '30%',
                                text: 'Умова продажу',
                                style: 'boldundeline'
                            },
                            {
                                width: '50%',
                                text: ['Попередня оплата'],
                                fontSize: 10
                            }
                        ],
                        margin: [0, 0, 0, 30]
                    },
                    {
                        text: [
                            'Рахунок-фактура №' + $rootScope.ENV.business.status.business_code + '-' + moment().format('YYYYMMDHHmm') +
                            '\n',
                            'від ' + moment().format('DD-MM-YYYY') + ' р.'],
                        style: 'header',
                        alignment: 'center',
                        margin: [0, 0, 0, 20]
                    },
                    {
                        table: {
                            widths: [20, '*', 30, 60, 60, 60],
                            body: [
                                [
                                    {text: '№', style: 'tableheader'},
                                    {text: 'Послуга', style: 'tableheader'},
                                    {text: 'Од.', style: 'tableheader'},
                                    {text: 'Кількість', style: 'tableheader'},
                                    {text: 'Ціна, грн.', style: 'tableheader'},
                                    {text: 'Сума, грн.', style: 'tableheader'}],
                                [
                                    {text: '1', style: 'tablecolumn'},
                                    {
                                        text: 'Поповнення особистого рахунку №' + $rootScope.ENV.business.status.business_code + ', inCust',
                                        style: 'tablecolumn'
                                    },
                                    {text: '', style: 'tablecolumn'},
                                    {text: '1.000', style: 'tablecolumn'},
                                    {text: $scope.model.amount_uah.toFixed(2) + ' ', style: 'tablecolumn'},
                                    {text: $scope.model.amount_uah.toFixed(2) + ' ', style: 'tablecolumn'}]
                            ]
                        }
                    },
                    {
                        table: {
                            widths: ['*', 60, 60],
                            body: [
                                [
                                    {text: 'Оплата без ПДВ', style: 'tablecolumn'},
                                    {text: 'Всього', style: 'tablecolumn'},
                                    {text: $scope.model.amount_uah.toFixed(2) + ' ', style: 'tablecolumn'}]
                            ]
                        },
                        layout: {
                            hLineWidth: function (i, node) {
                                if (i === 0)
                                    return 0;
                                else
                                    return 1;
                            },
                            vLineWidth: function (i, node) {
                                return 1;
                            }
                        },
                        margin: [0, 0, 0, 20]
                    },
                    {
                        text: 'Всього на суму: ' + $scope.model.amount_uah.toFixed(2) + ' грн.',
                        fontSize: 11,
                        margin: [0, 0, 0, 10]
                    },
                    {
                        text: 'Виписав(ла):',
                        fontSize: 11,
                        alignment: 'right',
                        margin: [0, 0, 150, 20]
                    },
                    {
                        text: 'Федченко В. О.',
                        fontSize: 11,
                        alignment: 'right',
                        margin: [0, 0, 50, 10]
                    },
                    {
                        image: $scope.img_seal,
                        alignment: 'right',
                        width: 90,
                        margin: [0, -90, 20, 0]
                    },
                    {
                        image: $scope.img_sign,
                        width: 80,
                        alignment: 'right',
                        margin: [0, -70, 30, 0]
                    },
                    {
                        text: 'Рахунок дійсний до сплати до ' + moment().add(10, 'days').format('DD.MM.YYYY'),
                        bold: true,
                        fontSize: 11
                    }
                ],
                defaultStyle: {
                    font: 'calibri'
                },
                styles: {
                    header: {
                        bold: true,
                        fontSize: 16
                    },
                    boldundeline: {
                        bold: true,
                        fontSize: 11,
                        margin: [10, 0, 0, 0]
                    },
                    tableheader: {
                        fontSize: 10,
                        bold: true
                    },
                    tablecolumn: {
                        fontSize: 10
                    }
                }
            };

        }

        function formBillPDFRU() {

            var client_info = [];

            if ($scope.legal_info.legal_ownership_type)
                client_info.push($scope.legal_info.legal_ownership_type + '\n');

            if ($scope.legal_info.name_for_invoice)
                client_info.push($scope.legal_info.name_for_invoice + '\n');

            if ($scope.legal_info.details_for_invoice)
                client_info.push($scope.legal_info.details_for_invoice + '\n');

            if ($scope.legal_info.post_address)
                client_info.push($scope.legal_info.post_address + '\n');

            if ($scope.legal_info.accounting_phone)
                client_info.push($scope.legal_info.accounting_phone + '\n');

            if ($scope.legal_info.accounting_email)
                client_info.push($scope.legal_info.accounting_email + '\n');

            if ($scope.legal_info.legal_address)
                client_info.push($scope.legal_info.legal_address + '\n');

            $scope.bill = {
                pageSize: 'A4',
                pageMargins: [40, 30, 40, 20], // left, top, right, bottom
                content: [
                    {
                        columns: [
                            {
                                width: '30%',
                                text: 'Поставщик',
                                style: 'boldundeline'
                            },
                            {
                                width: '70%',
                                text: [
                                    'Общество с Ограниченной Ответственностью "Софтпанорама Плюс Плюс"\n',
                                    'ИНН 32849350\n',
                                    'Украина 02152, г.Киев, пр-т Тычины, 20\n',
                                    'Тел. Бухгалтерия: +38-044-2201515\n',
                                    'Тел. +38044-394-9594\n\n',
                                    'Beneficiary: Softpanorama plus plus limited liability partnership\n',
                                    'Account #: UA573007110000026006052695978\n',
                                    'Beneficiary’s bank:  JSC CB "PRIVATBANK", 1D HRUSHEVSKOHO STR., KYIV, 01001, UKRAINE\n',
                                    'SWIFT code :  PBANUA2X\n',
                                    'CORRESPONDENT BANKS: ОАО Белинвестбанк,Минск, Беларусь\n',
                                    'Account in the correspondent bank BY61BLBB17020009999920100001\n',
                                    'SWIFT Code of the correspondent bank BLBBBY2XXXX\n',
                                    'Сorrespondent′s bank аccount in the intermediary bank 30111810800000000154\n',
                                    'Intermediary bank ПАО СБЕРБАНК, Москва, Россия\n',
                                    'SWIFT, БИК, ІПН, КПП БАНКА-ПОСРЕДНИКА/IDENTIFICATION CODE OF THE INTERMEDIARY BANK\n',
                                    'SABRRUMM,044525225,7707083893,775001001\n',
                                    'НОМЕР РАХУНКУ БАНКА-ПОСЕРЕДНИКА В ГУ Банка Росії по ЦФО 30101810400000000225\n'
                                ],
                                fontSize: 10
                            }
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        columns: [
                            {
                                width: '30%',
                                text: 'Получатель',
                                style: 'boldundeline'
                            },
                            {
                                width: '50%',
                                text: client_info,
                                fontSize: 10
                            }
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        columns: [
                            {
                                width: '30%',
                                text: 'Плательщик',
                                style: 'boldundeline'
                            },
                            {
                                width: '50%',
                                text: ['Тот же'],
                                fontSize: 10
                            }
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        columns: [
                            {
                                width: '30%',
                                text: 'Условие продажи',
                                style: 'boldundeline'
                            },
                            {
                                width: '50%',
                                text: ['Предоплата'],
                                fontSize: 10
                            }
                        ],
                        margin: [0, 0, 0, 30]
                    },
                    {
                        text: [
                            'Счет-фактура №' + $rootScope.ENV.business.status.business_code + '-' + moment().format('YYYYMMDHHmm') + '\n',
                            'от ' + moment().format('DD-MM-YYYY') + ' г.'],
                        style: 'header',
                        alignment: 'center',
                        margin: [0, 0, 0, 20]
                    },
                    {
                        table: {
                            widths: [20, '*', 30, 60, 60, 60],
                            body: [
                                [
                                    {text: '№', style: 'tableheader'},
                                    {text: 'Услуга', style: 'tableheader'},
                                    {text: 'Ед.', style: 'tableheader'},
                                    {text: 'Количество', style: 'tableheader'},
                                    {text: 'Цена, руб.', style: 'tableheader'},
                                    {text: 'Сумма, руб.', style: 'tableheader'}],
                                [
                                    {text: '1', style: 'tablecolumn'},
                                    {
                                        text: 'Пополнение личного счета №' + $rootScope.ENV.business.status.business_code + ', inCust',
                                        style: 'tablecolumn'
                                    },
                                    {text: '', style: 'tablecolumn'},
                                    {text: '1.000', style: 'tablecolumn'},
                                    {text: $scope.model.amount_rub.toFixed(2) + ' ', style: 'tablecolumn'},
                                    {text: $scope.model.amount_rub.toFixed(2) + ' ', style: 'tablecolumn'}]
                            ]
                        }
                    },
                    {
                        table: {
                            widths: ['*', 60, 60],
                            body: [
                                [
                                    {text: 'Оплата без НДС', style: 'tablecolumn'},
                                    {text: 'Итого', style: 'tablecolumn'},
                                    {text: $scope.model.amount_rub.toFixed(2) + ' ', style: 'tablecolumn'}]
                            ]
                        },
                        margin: [0, 0, 0, 20]
                    },
                    {
                        text: 'Всего на сумму: ' + $scope.model.amount_rub.toFixed(2) + ' руб.',
                        fontSize: 11,
                        margin: [0, 0, 0, 40]
                    },
                    {
                        text: 'Счет действителен к оплате до ' + moment().add(10, 'days').format('DD.MM.YYYY'),
                        alignment: 'right',
                        bold: true,
                        fontSize: 11
                    }
                ],
                defaultStyle: {
                    font: 'calibri'
                },
                styles: {
                    header: {
                        bold: true,
                        fontSize: 16
                    },
                    boldundeline: {
                        bold: true,
                        fontSize: 11,
                        margin: [10, 0, 0, 0]
                    },
                    tableheader: {
                        fontSize: 10,
                        bold: true
                    },
                    tablecolumn: {
                        fontSize: 10
                    }
                }
            };

        }

        $scope.onPayFlutterwave = function () {

            if (!$scope.model.amount_flutterwave || ($scope.model.amount_flutterwave && $scope.model.amount_flutterwave < $scope.model.amount_min)) {
                $scope.inlineMessage = 'Minimum amount';
                return
            }

            if ($scope.model.amount_flutterwave) {
                var post_data = {
                    amount: $scope.model.amount_flutterwave,
                    currency: $rootScope.ENV.business.currency
                };

                BusinessService.AccountRefillFlutterwaveNew(post_data, function (success, response) {
                    if (success) {
                        $window.ga('send', 'event', 'Business panel', 'Payment', post_data.amount + post_data.currency);

                        window.open(response.payment_processing_url, '_blank');
                    }
                });
            }
        };
    }
})();
